//if option-value is clicked, remove any siblings' .active class, and add it to the option-value
document.querySelectorAll('.option-value').forEach(optionValue => {
    optionValue.addEventListener('click', (e) => {
        e.target.parentNode.querySelectorAll('.option-value').forEach(optionValue => {
            optionValue.classList.remove('active');
        });
        optionValue.classList.add('active');
        updateSelectedVariant();
    });
});

const updateSelectedVariant = () => {
    //user has clicked. figure out the current variant and set the price and add to cart button variant attribute
    let optionValues = Array.from(document.querySelectorAll('.option-value:not(.cart_attr).active')).map(optionValue => optionValue.textContent);
    let variant = variants.find(variant => compareArrays(variant.options, optionValues));
    // console.log("variant", variant);
    document.querySelectorAll("[data-add-variant]").forEach(el => el.setAttribute("data-add-variant", variant.id));
    document.querySelectorAll("[variant-price]").forEach(el => el.classList.remove("active"));
    document.querySelector(`[variant-price="${variant.id}"]`).classList.add("active");
    //if variant available, add "sold-out" to .add-to-cart. otherwise, remove it
    let addToCart = document.querySelector(".add-to-cart-wrapper");
    console.log(variant);
    if (variant.available) {
        addToCart.classList.remove("sold-out");
    } else {
        addToCart.classList.add("sold-out");
    }
}

function compareArrays(longerArray,shorterArray) {
    for (let i = 0; i < shorterArray.length; i++) {
        if (shorterArray[i] !== longerArray[i]) {
            return false;
        }
    }
    return true;
}


document.querySelectorAll('[data-option-type="Color"] .option-value,[data-option-type="Type"] .option-value').forEach(optionValue => {
    optionValue.addEventListener('click', (e) => {
        console.log(e.target.textContent);
        window.changeMaterialColor(e.target.textContent.indexOf("Gold")> -1 ? 0xc9ba59 : 0xffffff);
        window.toggleEnvMap(e.target.textContent.indexOf("Gold") > -1);
    });
});

document.querySelectorAll('[data-option-type="Finish"] .option-value,[data-option-type="Type"] .option-value').forEach(optionValue => {
    optionValue.addEventListener('click', (e) => {
        //checking for words Satin or Matte right now and making less shiny...
        window.changeReflectiveness(e.target.textContent.indexOf("Satin")> -1 || e.target.textContent.indexOf("Matte")> -1);
    });
});

// product-info-dropdown-title
// product-info-dropdown-content

// on click product-info-dropdown-title, toggle a class on product-info-dropdown-content "open"

document.querySelectorAll('.product-info-dropdown-title').forEach(title => {
    title.addEventListener('click', (e) => {
        e.target.parentNode.classList.toggle('open');
    });
});

updateSelectedVariant();

//when user clicks on .option-value, check if we scrolled past the beginning of .product-detail. if not, smoothly scoll to it
document.querySelectorAll('.option-value').forEach(optionValue => {
    optionValue.addEventListener('click', (e) => {
        let productDetail = document.querySelector('.product-detail');
        if (window.scrollY < productDetail.offsetTop) {
            window.scrollTo({
                top: productDetail.offsetTop,
                behavior: 'smooth'
            });
        }
    });
});